/* Back to top button (OL-3577).

   Show/hide is a plain scroll-progress threshold: the button appears
   once the shopper has scrolled SHOW_AFTER_FRACTION of the page, and
   clicking returns them to the top of the document.

   This deliberately replaced an earlier IntersectionObserver approach
   that watched the add to cart button and scrolled back to the product
   title. That version depended on resolving specific elements in the
   product info column, and broke twice for different reasons: first
   because .product__title renders twice (mobile and desktop copies,
   toggled with display) so it scrolled to a hidden zero-height copy,
   then again with an iOS Safari-only failure where the button showed
   too early. A scroll fraction has no element dependencies at all, so
   it behaves the same on every browser and can't be thrown off by
   duplicated, conditionally-hidden, or app-injected markup in the buy
   box.

   The idle-shrink state is plain CSS (component-back-to-top.css) driven
   by the .is-idle class toggled here after IDLE_DELAY_MS with no
   scrolling; the hover/focus pill reveal is pure CSS with no JS. */
(function () {
  var IDLE_DELAY_MS = 2000;
  var SHOW_AFTER_FRACTION = 0.25;

  function bind(button) {
    if (button.dataset.backToTopBound) return;
    button.dataset.backToTopBound = 'true';

    var idleTimer = null;
    var ticking = false;

    var resetIdleTimer = function () {
      button.classList.remove('is-idle');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        button.classList.add('is-idle');
      }, IDLE_DELAY_MS);
    };

    var update = function () {
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      // Guard against pages too short to scroll, where the fraction is
      // meaningless and the button should simply never appear.
      var progress = maxScroll > 0 ? window.pageYOffset / maxScroll : 0;
      var shouldShow = progress >= SHOW_AFTER_FRACTION;

      if (button.hidden === shouldShow) button.hidden = !shouldShow;
      if (shouldShow) resetIdleTimer();
    };

    // rAF-throttled: scroll fires far more often than the button can
    // usefully change, and this reads layout (scrollHeight).
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Run once on bind so a restored scroll position (back navigation,
    // deep link to an anchor) shows the button without needing a scroll.
    update();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-back-to-top]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });

  // Theme editor: sections are re-rendered on edit, so re-bind the new nodes.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
